import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d3b8de62"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "noData"
};
import { onMounted, ref } from "vue";
import { Bar } from "vue-chartjs";
import { APPLICATION_STATUS_PALETTE } from "./model";
import { BarElement, CategoryScale, Chart, Legend, LinearScale, Tooltip } from 'chart.js';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BarChart',
    props: {
        data: {}
    },
    setup(__props) {
        Chart.register(CategoryScale, LinearScale, BarElement, Legend, Tooltip);
        Chart.defaults.font.size = 14;
        Chart.defaults.font.weight = 'bold';
        const props = __props;
        const chart = ref(null);
        onMounted(() => {
            chart.value = {
                data: {
                    labels: props.data.labels,
                    datasets: props.data.groups.map((group, i) => ({
                        label: group.name,
                        data: group.values,
                        backgroundColor: APPLICATION_STATUS_PALETTE[i],
                    }))
                },
                options: {
                    scales: {
                        x: { stacked: true },
                        y: { beginAtZero: true, stacked: true }
                    },
                    plugins: {
                        legend: { display: true, position: 'bottom' }
                    }
                },
                style: {
                    position: 'relative',
                    'max-height': '35vh'
                }
            };
        });
        return (_ctx, _cache) => {
            return (_ctx.data.groups.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No data for this period "))
                : (chart.value)
                    ? (_openBlock(), _createBlock(_unref(Bar), {
                        key: 1,
                        id: `chart-${Math.random()}`,
                        options: chart.value.options,
                        style: _normalizeStyle(chart.value.style),
                        data: chart.value.data
                    }, null, 8, ["id", "options", "style", "data"]))
                    : _createCommentVNode("", true);
        };
    }
});
